<template>
  <div id="points-index">
    <header><img src="@/assets/img/logo.png" alt=""></header>

    <!-- remind-modal -->
    <div class="remind-popup" v-if="isRemindPopup">
      <div class="remind-popup-wrapper">
        <div class="remind-content">
          <h2>{{ remindTitle }}</h2>
          <p>{{ remindText }} <span v-show="!isBind">【<a href="javascript:void(0);" @click="closeRemind()">會員綁定</a>】</span></p>
          <div class="remind-button">
            <button class="close_button" @click="isRemindPopup = false"><img src="@/assets/img/modal_close.png"
                alt=""></button>
            <button class="confirm_button" @click="closeRemind()"><img src="@/assets/img/remind_button.png"
                alt=""></button>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="wrapper">
        <div class="nav-area">
          <div class="nav-return" @click="toUrl('home')">
            <img src="@/assets/img/return_page.png" alt="">
          </div>
          <div class="nav-title">
            <img src="@/assets/img/points_title.png" alt="">
          </div>
          <div class="nav-log" @click="toUrl('exchange-log')">
            <img src="@/assets/img/log.png" alt="">
          </div>
        </div>
        <div class="product">
          <p class="product-point">我的點數<span>{{ point }}</span>點</p>
          <p class="product-border"></p>
          <div class="loading" id="waitingPageLoading" v-show="loading">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="product-area" v-for="product in list" :key="product.seq"
            @click="toUrl('points-info', product.seq)">
            <div class="product-img">
              <img :src="product.img || '@/assets/img/test.png'" alt="">
            </div>
            <div class="product-info">
              <p class="product-title">{{ product.title }}<br><span>{{ formatLimit(product.description) }}</span></p>
              <div class="product-detailed">
                <p>{{ product.start_redeem }}-{{ product.end_redeem }}</p>
                <div class="product-text">
                  <p>剩餘組數{{ product.inventory }}組</p>
                  <p class="point"><img src="@/assets/img/point.png" alt="">{{ product.point }}點</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/utils/Api';

export default {
  name: 'points',
  data() {
    return {
      api: {},
      list: [],
      point: 0,
      loading: true,
      isRemindPopup: false,
      isBind: true,
    }
  },
  mounted() {
    document.body.style.background = '#060606'
    this.initial();
  },
  methods: {
    async initial() {
      let accessToken = this.$root.$data.accessToken;
      let api = new Api(accessToken, accessToken);
      try {
        let { data: { data } } = await api.getProducts();
        this.list = data.list;
        this.point = data.point;
      } catch (error) {
        let errorMessage = "未知錯誤";
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        this.remindTitle = '錯誤訊息';


        if (errorMessage === '請先進行綁定') {
        this.remindText = '您尚未綁定會員 無法兌換點數 請您先進行';
        this.isRemindPopup = true;
        this.isBind = false;
      } else {
        this.remindText = errorMessage;
        this.isRemindPopup = true;
      }

      } finally {
        this.loading = false;
      }
    },
    closeRemind() {
      if (this.remindText === '您尚未綁定會員 無法兌換點數 請您先進行') {
        sessionStorage.setItem('goBackUrl', location.href);
        location.href = `${location.origin}/web/member/bind/index.html`;
      } else {
        this.isRemindPopup = false;
      }
    },
    toUrl(val, productSeq) {
      this.$router.push({ path: `/${val}`, query: { seq: productSeq } });
    },
    formatLimit(val) {
      if (!val) return;
      return val.length > 50 ? `${val.slice(0, 50)}...` : val;
    },
  },
};
</script>

<style scoped>
.container {
  font-family: 'Roboto', sans-serif;
}

p {
  margin: 0;
}

button {
  background: none;
  border: none;
}

button:focus {
  outline: none;
}


.status-color {
  color: var(--bronze);
}

header {
  position: relative;
}

/* nav */
.nav-area {
  display: flex;
  padding: 10px 0 30px 0;
  align-items: flex-end;
  justify-content: space-around;
}

.nav-area .nav-return {
  width: 8.5%;
}

.nav-area .nav-title {
  width: 29%;
  margin-left: 26px;
}

.nav-area .nav-log {
  width: 16%;
}

/* product */
.product {
  padding: 0px 25px;
}

.product .product-point {
  color: #fff;
  text-align: justify;
  font-size: 16px;
  font-weight: bold;
}

.product .product-point span {
  color: #eed061;
  font-size: 26px;
  margin: 0 2px;
  font-weight: bold;
}

.product .product-border {
  border-bottom: 2px solid #fdf2c9;
  margin: 10px 0 10px 0;
}

.product .product-area {
  display: flex;
  gap: 10px;
  padding-bottom: 25px;
  color: #fff;
}

.product-area .product-img {
  position: relative;
  width: 60%;
  min-height: 122px;
  box-shadow: 1px 1px 0px 0px rgba(0, 0, 0, 0.2);
}

.product-area .product-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: start;
  width: 100%;
  line-height: 18px;
  font-size: 12px;
}

.product-area .product-info .product-title {
  font-weight: bold;
  font-size: 18px;
}

.product-area .product-info .product-title span {
  color: #fdf2c9;
  font-size: 14px;
}

.product-area .product-detailed p {
  font-size: 14px;
}

.product-area .product-detailed .product-text {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.product-area .product-detailed .product-text .point {
  color: #eed061;
  font-size: 20px;
  font-weight: bold;
}

.product-area .product-detailed .product-text .point img {
  width: 16px;
  margin-right: 2px;
}

/* remind-modal */

.remind-popup {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 999;
  opacity: 1;
  visibility: visible;
  overflow: hidden;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  overflow-x: hidden;
}

.remind-popup-wrapper {
  position: absolute;
  background: #fff;
  padding: 15px 25px 30px 25px;
  width: 95%;
  max-width: 400px;
  max-height: 88%;
  -webkit-box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.3);
  text-align: center;
}

.remind-content h2 {
  font-size: 20px;
  font-weight: bold;
  color: #c0272b;
  margin: 25px 0;
}

.remind-content p {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

.remind-content span {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

.remind-content a {
  color: #007aff;
  text-decoration: underline !important;
}

.remind-button {
  display: flex;
  justify-content: space-between;
}

.remind-button img {
  display: block;
  margin: auto;
  width: 90%;
  padding: 20px 0 20px 0;
}

/* @media (min-width: 361px) {

  .product-area .product-detailed .product-text .point {
    color: #eed061;
    font-size: 14px;
  }
}

@media (min-width: 376px) {

  .product-area .product-detailed .product-text .point {
    color: #eed061;
    font-size: 16px;
  }
}

@media (min-width: 400px) {

  .product-area .product-detailed .product-text .point {
    color: #eed061;
    font-size: 18px;
  }

  .product-area .product-detailed .product-text .point img {
    width: 14px;
  }
}

@media (max-width: 350px) {
  .product {
    padding: 0px 7px;
  }
} */
</style>